import { useContext } from 'react';

import {
    AlertProvider,
    AlertContext,
    Alert,
} from './components/AlertProvider';

export const useAlert = (): Alert => useContext(AlertContext);

export { AlertProvider };
